import { EnvironmentProviders } from '@angular/core';
import { userInitializerProvider } from './user.provider';
import { talkJsInitializerProvider } from './talkjs.provider';

export const appInitializer: EnvironmentProviders[] = [userInitializerProvider, talkJsInitializerProvider];
